// extracted by mini-css-extract-plugin
module.exports = {"bigBanner":"BigBanner--bigBanner--2anMI","contactModal":"BigBanner--contactModal--2Qq0y"};